import React from "react";

const NotificationContext = React.createContext();

export default NotificationContext;
